import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataEnum,
  ODataDateTime,
  ODataDecimal
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 3,
});

export default function getMembershipHistoryHeaders(enums) {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      searchable: false,
    }),
    // new ODataHeader({
    //   title: "headers.member_transactions.Transaction Type",
    //   type: new ODataEnum("Type", {
    //     getString: (item) => {
    //       return i18n.t("enums." + item.Type);
    //     },
    //     dropdownItems: enums.Type,
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    new ODataHeader({
      type: new ODataString("Term/Id"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("Term/Year"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "headers.hourshistory.employer_contribution_term",
      type: new ODataString("Term/Name", {
        getString: (item) => item.Term.Name + " " + item.Term.Year
      }),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "Term/Name"
    }),
    new ODataHeader({
      title: "globals.start_date",
      type: new ODataDate("Term/StartDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.end_date",
      type: new ODataDate("Term/EndDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.hourshistory.total_amount",
      type: new ODataDecimal("TotalAmount", {
        getString: (item, type) => {
          const value = item.TotalAmount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return value.toFixed(2)
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.reason",
      type: new ODataEnum("Activity", {
        getString: (item) => {
          return i18n.t("enums." + item.Activity);
        },
        dropdownItems: enums.Activity,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("User"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("UserType"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataString("ClaimSubmission/Identifier", {
        getString: (item) => {
          if (item.User!==null && item.User!==undefined && item.UserType!==null && item.UserType!==undefined) {
            return `${item.UserType} (${item.User})`
          }
          return item.ClaimSubmission.Identifier;
        },
      }),
      sortable: false,
      visible: true,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
}
